import { makeAutoObservable } from 'mobx'
import * as API from '../../service/api/SystemApi'
import { SYSTEM_KEY } from 'service/config'

class SystemInfoStore {
  constructor() {
    makeAutoObservable(this)
  }

  initSystemInfo = async (data) => {
    const res = await API.GET_SYSTEM_CONFIG_INFO(data)
    if (res.data) {
      try {
        sessionStorage.setItem(SYSTEM_KEY, JSON.stringify(res.data))
      } catch (error) {}
    }
    return res
  }
}

export default new SystemInfoStore()
